import React, { useState, useEffect } from "react";

import {
  Form,
  Input,
  Button,
  message,
  Tabs,
  Cascader,
  Select,
  Space,
  Drawer,
  Radio,
} from "antd";

import { StopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import moment from "moment";

import { Http } from "../../Http";
import queryString from "query-string";

import { areaTree, cateTree } from "../../Tree.js";

import Thumb from "../../component/Thumb.js";
import Editor from "../../component/Editor.js";

import s1 from "../../images/template_s1.jpg";
import s2 from "../../images/template_s2.jpg";
import s3 from "../../images/template_s3.jpg";
import s4 from "../../images/template_s4.jpg";
import s5 from "../../images/template_s5.jpg";
import s6 from "../../images/template_s6.jpg";
import s7 from "../../images/template_s7.jpg";
import s8 from "../../images/template_s8.jpg";
import s9 from "../../images/template_s9.jpg";
import s10 from "../../images/template_s10.jpg";
import s11 from "../../images/template_s11.jpg";

import styles from "./BrandSave.module.less";

const { Option } = Select;
const { TabPane } = Tabs;

function BrandSave({ navigate, location }) {
  const { state } = location;
  const { data, search, pagination } = state;

  const [submit, setSubmit] = useState(false);
  const [banner, setBanner] = useState([]);
  const [status, setStatus] = useState(0);
  const [drawer, setDrawer] = useState(false);

  const [form] = Form.useForm();

  const theme = [
    { name: "1号模板", pic: s1 },
    { name: "2号模板", pic: s2 },
    { name: "3号模板", pic: s3 },
    { name: "4号模板", pic: s4 },
    { name: "5号模板", pic: s5 },
    { name: "6号模板", pic: s6 },
    { name: "7号模板", pic: s7 },
    { name: "8号模板", pic: s8 },
    { name: "9号模板", pic: s9 },
    { name: "10号模板", pic: s10 },
    { name: "11号模板", pic: s11 },
  ];

  const onBack = () => {
    navigate("../", { state: { search, pagination } });
  };

  const onFinish = async (values) => {
    setSubmit(true);
    if (data) {
      values.id = data.id;
    }
    for (let s in banner) {
      if (banner[s].url) {
        if (
          banner[s].url.includes("oss.chinaqyz.com") ||
          banner[s].url.includes("upload.chinaqyz.com")
        )
          values[banner[s].field] = banner[s].url;
      }
    }
    values.sitePage = values.sitePage ? values.sitePage : "";
    values.freephone = values.freephone ? values.freephone : "";
    values.telephone = values.telephone ? values.telephone : "";
    values.theme = `s${values.theme.replace(/[^0-9]/gi, "")}`;
    let para = queryString.stringify(values);
    try {
      let parsed = await Http.post(`brand/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onBack();
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    if (data) {
      setBanner([
        {
          name: "电脑端轮播图（1）",
          field: "webBanner1",
          url: data.webBanner1,
        },
        {
          name: "电脑端轮播图（2）",
          field: "webBanner2",
          url: data.webBanner2,
        },
        {
          name: "电脑端轮播图（3）",
          field: "webBanner3",
          url: data.webBanner3,
        },
        {
          name: "电脑端轮播图（4）",
          field: "webBanner4",
          url: data.webBanner4,
        },
        {
          name: "移动端轮播图（1）",
          field: "wapBanner1",
          url: data.wapBanner1,
        },
        {
          name: "移动端轮播图（2）",
          field: "wapBanner2",
          url: data.wapBanner2,
        },
        {
          name: "移动端轮播图（3）",
          field: "wapBanner3",
          url: data.wapBanner3,
        },
        {
          name: "移动端轮播图（4）",
          field: "wapBanner4",
          url: data.wapBanner4,
        },
      ]);
      data.cate = [data.parentId, data.childId];
      data.area = [data.provinceId, data.cityId, data.regionId];
      data.expiredTime = moment(data.expiredTime);
      data.theme = `${data.theme.replace(/[^0-9]/gi, "")}号模板`;
      data.status = data.status === 0 ? 0 : 3;
      setStatus(data.status === 0 ? 0 : 3);
      form.setFieldsValue(data);
    }
  }, [data]);

  return (
    <div className={styles.BrandSave}>
      <Form labelCol={{ span: 2 }} form={form} onFinish={onFinish}>
        <Tabs defaultActiveKey="1" type="card">
          <TabPane tab="基本信息" key="1" forceRender={true}>
            <Form.Item
              label="品牌名称"
              name="name"
              rules={[
                { required: true, message: "请输入品牌名称, 如格力空调" },
              ]}
              wrapperCol={{ span: 8 }}
            >
              <Input placeholder="请输入品牌名称, 如格力空调" />
            </Form.Item>
            <Form.Item
              label="品牌英文名"
              name="alias"
              rules={[
                {
                  required: true,
                  pattern: /^[a-z][a-z0-9]{4,14}$/,
                  message: "必须以英文开头5-15位字符, 只允许小写字母和数字",
                },
                {
                  validator: (rule, value) => {
                    if (value) {
                      let para = { alias: value };
                      if (form.getFieldValue("id")) {
                        para.id = form.getFieldValue("id");
                      }
                      return Http.get("brand/unique", {
                        searchParams: para,
                      })
                        .json()
                        .then((parsed) => {
                          if (parsed.state === "ok") {
                            throw "此英文名称已存在, 请更改!";
                          } else {
                            let keep = [
                              "admin",
                              "guest",
                              "baidu",
                              "sogou",
                              "weibo",
                              "weixin",
                              "china",
                            ];
                            if (keep.includes(value.trim())) {
                              throw `${value}是保留名称，请重新输入一个名称`;
                            }
                          }
                        });
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
              wrapperCol={{ span: 8 }}
            >
              <Input
                disabled={form.getFieldValue("alias") ? true : false}
                placeholder="请输入品牌英文名, 只能填写小写字母或数字"
              />
            </Form.Item>
            <Form.Item
              label="所属行业"
              name="cate"
              rules={[{ required: true, message: "请选择所属行业" }]}
              wrapperCol={{ span: 8 }}
            >
              <Cascader options={cateTree} placeholder="请选择所属行业" />
            </Form.Item>
            <Form.Item
              label="所在地区"
              name="area"
              rules={[{ required: true, message: "请选择所在地区" }]}
              wrapperCol={{ span: 8 }}
            >
              <Cascader options={areaTree} placeholder="请选择所在地区" />
            </Form.Item>
            <Form.Item
              label="价格区间"
              style={{ marginBottom: 0 }}
              required
              wrapperCol={{ span: 8 }}
            >
              <Form.Item
                name="minPrice"
                rules={[{ required: true, message: "请输入最低价格" }]}
                style={{
                  display: "inline-block",
                  width: "calc(50% - 8px)",
                }}
              >
                <Input suffix="￥" type="number" placeholder="请输入最低价格" />
              </Form.Item>
              <Form.Item
                name="maxPrice"
                rules={[{ required: true, message: "请输入最高价格" }]}
                style={{
                  display: "inline-block",
                  width: "calc(50% - 8px)",
                  margin: "0 0 0 16px",
                }}
              >
                <Input suffix="￥" type="number" placeholder="请输入最高价格" />
              </Form.Item>
            </Form.Item>
            <Form.Item
              label="物流费用"
              style={{ marginBottom: 0 }}
              required
              wrapperCol={{ span: 8 }}
            >
              <Form.Item
                name="express"
                rules={[
                  {
                    required: true,
                    message: "请填写物流费用",
                  },
                ]}
                style={{
                  display: "inline-block",
                  width: "calc(100% - 368px)",
                }}
              >
                <Input placeholder="请填写物流费用" />
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  width: "64px",
                  margin: "0 0 0 16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => form.setFieldsValue({ express: "包邮" })}
                >
                  包邮
                </Button>
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  width: "88px",
                  margin: "0 0 0 16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => form.setFieldsValue({ express: "上门自提" })}
                >
                  上门自提
                </Button>
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  width: "88px",
                  margin: "0 0 0 16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => form.setFieldsValue({ express: "货到付款" })}
                >
                  货到付款
                </Button>
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  width: "64px",
                  margin: "0 0 0 16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => form.setFieldsValue({ express: "面议" })}
                >
                  面议
                </Button>
              </Form.Item>
            </Form.Item>
            <Form.Item
              label="计量单位"
              style={{ marginBottom: 0 }}
              required
              wrapperCol={{ span: 8 }}
            >
              <Form.Item
                name="unit"
                rules={[
                  {
                    required: true,
                    message: "请填写计量单位",
                  },
                ]}
                style={{
                  display: "inline-block",
                  width: "calc(100% - 248px)",
                }}
              >
                <Input placeholder="请填写计量单位" />
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  margin: "0 0 0 16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => form.setFieldsValue({ unit: "个" })}
                >
                  个
                </Button>
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  margin: "0 0 0 16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => form.setFieldsValue({ unit: "件" })}
                >
                  件
                </Button>
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  margin: "0 0 0 16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => form.setFieldsValue({ unit: "套" })}
                >
                  套
                </Button>
              </Form.Item>
              <Form.Item
                style={{
                  display: "inline-block",
                  margin: "0 0 0 16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => form.setFieldsValue({ unit: "吨" })}
                >
                  吨
                </Button>
              </Form.Item>
            </Form.Item>
            <Form.Item
              label="联系人"
              name="contactName"
              rules={[{ required: true, message: "请输入联系人" }]}
              wrapperCol={{ span: 8 }}
            >
              <Input placeholder="请输入联系人" />
            </Form.Item>
            <Form.Item
              label="待排名词"
              name="keyword"
              rules={[
                {
                  required: true,
                  message: "请输入待排名词，比如“家电清洗,英语培训班”",
                },
              ]}
              wrapperCol={{ span: 8 }}
            >
              <Input placeholder="请输入待排名词，比如“家电清洗,英语培训班”" />
            </Form.Item>
            <Form.Item
              label="简介"
              rules={[{ required: true, message: "请输入公司或品牌简介" }]}
              name="description"
              wrapperCol={{ span: 8 }}
            >
              <Input.TextArea placeholder="请输入公司或品牌简介" />
            </Form.Item>
            <Form.Item
              label="主营业务"
              name="business"
              rules={[{ required: true, message: "请输入主营业务" }]}
              wrapperCol={{ span: 8 }}
            >
              <Input placeholder="请输入主营业务" />
            </Form.Item>
            <Form.Item label="网站" name="sitePage" wrapperCol={{ span: 8 }}>
              <Input placeholder="请输入网站网址，http:// 或 https:// 开头" />
            </Form.Item>
            <Form.Item
              label="400电话"
              name="freephone"
              wrapperCol={{ span: 8 }}
            >
              <Input placeholder="请输入400电话, 没有请填写无" />
            </Form.Item>
            <Form.Item label="座机" name="telephone" wrapperCol={{ span: 8 }}>
              <Input placeholder="请输入座机, 没有请填写无" />
            </Form.Item>
            <Form.Item
              label="手机"
              name="cellphone"
              rules={[{ required: true, message: "请输入手机" }]}
              wrapperCol={{ span: 8 }}
            >
              <Input placeholder="请输入手机, 没有请填写无" />
            </Form.Item>
            <Form.Item
              label="地址"
              name="address"
              rules={[{ required: true, message: "请输入公司地址" }]}
              wrapperCol={{ span: 8 }}
            >
              <Input placeholder="请输入公司地址" />
            </Form.Item>
            <Form.Item
              label="网站模板"
              name="theme"
              rules={[{ required: true, message: "请选择网站模板" }]}
              wrapperCol={{ span: 8 }}
            >
              <Input
                onClick={() => {
                  setDrawer(true);
                }}
                placeholder="请选择模板"
              />
            </Form.Item>
            <Form.Item
              label="LOGO"
              name="logo"
              rules={[{ required: true, message: "请上传LOGO" }]}
              wrapperCol={{ span: 8 }}
            >
              <Thumb onClick={() => message.warn("用户自行修改！")} />
            </Form.Item>
          </TabPane>
          <TabPane tab="品牌介绍" key="2" forceRender={true}>
            <Form.Item name="content" wrapperCol={{ span: 10 }}>
              <Editor />
            </Form.Item>
          </TabPane>
          <TabPane tab="轮播广告" key="3" forceRender={true}>
            <Tabs defaultActiveKey="webBanner1" tabPosition="left">
              {banner.map((value) => (
                <TabPane tab={value.name} key={value.field}>
                  <div
                    className={styles.bannerThumb}
                    onClick={() => {
                      message.warn("用户自行修改！");
                    }}
                  >
                    {value.url ? (
                      <div className={styles.thumb}>
                        <img src={value.url} alt="" />
                      </div>
                    ) : (
                      <div className={styles.upload}>
                        <StopOutlined />
                        <i>未上传</i>
                      </div>
                    )}
                  </div>
                </TabPane>
              ))}
            </Tabs>
          </TabPane>
          <TabPane tab="客服代码" key="4" forceRender={true}>
            <Form.Item name="script" wrapperCol={{ span: 10 }}>
              <Input.TextArea
                placeholder="这里可以填写您的 53客服、美洽客服、百度商桥、QQ企业客服等各平台的客服代码。"
                style={{ height: 140 }}
              />
            </Form.Item>
          </TabPane>
          <TabPane tab="口令营销" key="5" forceRender={true}>
            <div className={styles.koulinTips}>
              <ExclamationCircleOutlined />
              <a href="https://ssh.chinaqyz.com/zt/klyx/" target="_blank">
                请点击查看详细功能说明！
              </a>
            </div>
            <Form.Item label="阿里巴巴" name="alibaba" wrapperCol={{ span: 8 }}>
              <Input placeholder="请输入阿里巴巴口令" />
            </Form.Item>
            <Form.Item label="淘宝" name="taobao" wrapperCol={{ span: 8 }}>
              <Input placeholder="请输入淘宝口令" />
            </Form.Item>
            <Form.Item label="抖音" name="douyin" wrapperCol={{ span: 8 }}>
              <Input placeholder="请输入抖音口令" />
            </Form.Item>
            <Form.Item label="快手" name="kuaishou" wrapperCol={{ span: 8 }}>
              <Input placeholder="请输入快手口令" />
            </Form.Item>
            <Form.Item label="火山" name="huoshan" wrapperCol={{ span: 8 }}>
              <Input placeholder="请输入火山口令" />
            </Form.Item>
          </TabPane>
        </Tabs>
        <div className={styles.review}>
          <Form.Item
            label="审核"
            name="status"
            rules={[{ required: true, message: "请选择状态" }]}
            wrapperCol={{ span: 8 }}
          >
            <Radio.Group
              onChange={(e) => {
                setStatus(e.target.value);
              }}
            >
              <Radio value={0}>驳回</Radio>
              <Radio value={3}>通过</Radio>
            </Radio.Group>
          </Form.Item>
          {status === 0 ? (
            <Form.Item
              label="原因"
              rules={[{ required: true, message: "请输入驳回原因" }]}
              name="reviewMsg"
              wrapperCol={{ span: 8 }}
            >
              <Input.TextArea placeholder="请输入驳回原因" rows={3} />
            </Form.Item>
          ) : null}
          <Form.Item wrapperCol={{ offset: 2 }}>
            <Space>
              <Button
                type="primary"
                disabled={submit}
                loading={submit}
                htmlType="submit"
              >
                提交
              </Button>
              <Button htmlType="button" onClick={onBack}>
                返回
              </Button>
            </Space>
          </Form.Item>
        </div>
      </Form>
      <Drawer
        title="模板选择"
        placement="right"
        width={502}
        closable
        onClose={() => {
          setDrawer(false);
        }}
        visible={drawer}
      >
        <div className={styles.template}>
          {theme.map((value) => (
            <div className={styles.col}>
              <div className={styles.pic}>
                <img src={value.pic} />
              </div>
              <div className={styles.tip}>
                <Button
                  type="primary"
                  onClick={() => {
                    form.setFieldsValue({ theme: value.name });
                    setDrawer(false);
                  }}
                >
                  使用
                </Button>
              </div>
            </div>
          ))}
        </div>
      </Drawer>
    </div>
  );
}

export default BrandSave;
